import { render, staticRenderFns } from "./CheckboxLabel.vue?vue&type=template&id=744b9228&"
import script from "./CheckboxLabel.vue?vue&type=script&lang=ts&"
export * from "./CheckboxLabel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports